import i18n from '../lang/i18n';
export default function (value, maxDigits = 2, minDigits = 0) {
	value = parseFloat(value);
	if (typeof value != 'undefined' && value != null) {
		return new Intl.NumberFormat(i18n.locale, { minimumFractionDigits: minDigits, maximumFractionDigits: maxDigits, useGrouping: false }).format(value);
	} else {
		return '';
	}
}
